import { fields } from "@monorepo/utils/src/variables/projectsData/receiptDocumentsBookReport/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.FILTER_ARCHIVE]: {},
  [fields.FILTER_PERIOD_FROM]: "",
  [fields.FILTER_PERIOD_TO]: "",
});
